import { CircularProgress } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Loader = styled(CircularProgress)(() => ({
  position: 'absolute',
}));
